<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./HomepageServices.translations.json";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { contactPathMap } from "../../../../core/schema/paths/contactPathMap.js";
	import Link from "../../../shared/components/Link.svelte";
	import Icon from "../../../shared/components/Icon.svelte";
	import service from "../../../../core/assets/icons/service.svg?raw";
	import chat from "../../../../core/assets/icons/chat.svg?raw";
	import arrowRightLong from "../../../../core/assets/icons/arrow-right-long.svg?raw";

	const { TENANT_LOCALE } = getGlobalSettings();
	const translate = getTranslate(translations);
	const localizedSupportLink = `https://support.vertiflex.eu/?lang=${TENANT_LOCALE}`;

	const cards = [
		{
			name: translate("helpdesk"),
			linkText: translate("goToHelpDesk"),
			link: localizedSupportLink,
			icon: service,
			target: "_blank",
		},
		{
			name: translate("contactUs"),
			linkText: translate("contactUs"),
			link: `/${contactPathMap[TENANT_LOCALE]}`,
			icon: chat,
		},
	];
</script>

<div class="flex flex-col">
	<h2 class="text-center">
		{translate("needHelp")}
		<br />
		{translate("contactUs")}
	</h2>
	<div class="mb-4 flex flex-col gap-2 xl:grid xl:grid-cols-2">
		{#each cards as card}
			<div class="bg-primary flex w-full flex-col justify-between gap-16 rounded-lg p-6 text-gray-300">
				<div class="flex w-full flex-col justify-start gap-8">
					<Icon icon={card.icon} class="h-[4.25rem] w-fit" />
					<span class="font-spaceGrotesk text-2md m-0 font-medium uppercase leading-7">{card.name}</span>
				</div>
				<div class="flex flex-col gap-8 md:gap-[2.5rem]">
					<Link
						asButton
						class="text-2xs font-semibold uppercase leading-[1.21] tracking-widest text-white"
						variant="transparent"
						target={card.target}
						icon={arrowRightLong}
						href={card.link}>{card.linkText}</Link
					>
				</div>
			</div>
		{/each}
	</div>
</div>
